<template>
  <div class="row">
    <div class="col-12 col-lg-6 col-xl-4">
      <div class="card">
        <div class="card-body">
          <router-link :to="{name: 'organisations.index'}" class="btn btn-primary">
            Organisation wählen
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StaffDashboard",
}
</script>
